import { userConstants } from '../constants';
import { userService } from '../services';
import { alertActions } from './';

export const userActions = {
  login,
  logout,
  getAll,
  create,
  updateStatus,
  deleteUser,
  updatePassword,
  resetpassword,
};

function login(username, password, props) {
  return dispatch => {
    dispatch(request({ username }));

    userService.login(username, password).then(
      user => {
        dispatch(success(user));
        if (user.role === 'ADMIN') {
          props.history.push('/admin');
        } else {
          props.history.push('/');
        }
      },
      error => {
        console.log(props.i18n.language);
        dispatch(failure(error));
        dispatch(alertActions.error(props.i18n.t('loginFailed')));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function getAll(pageNumber, props) {
  return dispatch => {
    dispatch(request());

    userService.getAll(pageNumber).then(
      response => {
        dispatch(success(response));
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userService.logout());
          dispatch(failure(error));
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('usersGetError')));
        }
      }
    );
  };

  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(result) {
    return { type: userConstants.GETALL_SUCCESS, result };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}

function create(user, props) {
  return dispatch => {
    dispatch(request({ user }));

    userService.create(user).then(
      user => {
        dispatch(success(user));
        dispatch(alertActions.success(props.i18n.t('registerSuccess')));
        props.history.push('/signin');
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(props.i18n.t('registerFailed')));
      }
    );
  };

  function request(user) {
    return { type: userConstants.CREATE_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.CREATE_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.CREATE_FAILURE, error };
  }
}

function updateStatus(userId, status, currentPage, props) {
  return dispatch => {
    dispatch(request({ status }));

    userService.updateStatus(userId, status, currentPage).then(
      response => {
        dispatch(success(response));
        dispatch(alertActions.success(props.i18n.t('userStatusUpdateSuccess')));
        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 10000);
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userService.logout());
          dispatch(failure(error));
          props.history.push('/signin');
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('genericError')));
        }
      }
    );
  };

  function request(status) {
    return { type: userConstants.USER_UPDATE_REQUEST, status };
  }
  function success(result) {
    return { type: userConstants.USER_UPDATE_SUCCESS, result };
  }
  function failure(error) {
    return { type: userConstants.USER_UPDATE_FAILURE, error };
  }
}

function deleteUser(userId, currentPage, props) {
  return dispatch => {
    dispatch(request({ userId }));

    userService.deleteUser(userId, currentPage).then(
      response => {
        dispatch(success(response));
        dispatch(alertActions.success(props.i18n.t('userDeletionSuccess')));
        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 10000);
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userService.logout());
          dispatch(failure(error));
          props.history.push('/signin');
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('genericError')));
        }
      }
    );
  };

  function request(status) {
    return { type: userConstants.DELETE_REQUEST, status };
  }
  function success(result) {
    return { type: userConstants.DELETE_SUCCESS, result };
  }
  function failure(error) {
    return { type: userConstants.DELETE_FAILURE, error };
  }
}

function updatePassword(userId, currentPassword, newPassword, props) {
  return dispatch => {
    dispatch(request('update password'));

    userService.updatePassword(userId, currentPassword, newPassword).then(
      response => {
        dispatch(success(response));
        dispatch(
          alertActions.success(props.i18n.t('userPasswordUpdateSuccess'))
        );
        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 10000);
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userService.logout());
          dispatch(failure(error));
          props.history.push('/signin');
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('genericError')));
        }
      }
    );
  };

  function request(status) {
    return { type: userConstants.USER_UPDATE_REQUEST, status };
  }
  function success(result) {
    return { type: userConstants.USER_UPDATE_SUCCESS, result };
  }
  function failure(error) {
    return { type: userConstants.USER_UPDATE_FAILURE, error };
  }
}
function resetpassword(userId, props) {
  return dispatch => {
    dispatch(request('reset password'));

    userService.resetPassword(userId).then(
      response => {
        dispatch(success(response));
        dispatch(
          alertActions.success(props.i18n.t('userPasswordResetSuccess'))
        );
        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 10000);
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userService.logout());
          dispatch(failure(error));
          props.history.push('/signin');
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('genericError')));
        }
      }
    );
  };

  function request(status) {
    return { type: userConstants.USER_RESET_REQUEST, status };
  }
  function success(result) {
    return { type: userConstants.USER_RESET_SUCCESS, result };
  }
  function failure(error) {
    return { type: userConstants.USER_RESET_FAILURE, error };
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.actions.js